import React from "react";

 export const globalContext = React.createContext()